import Vue from 'vue'
import { API_URL } from '@/config'

export const rooms = {

  namespaced: true,

  state: {
    rooms: [],
  },

  getters: {
    rooms: state => state.rooms,
  },

  mutations: {
    setRooms(state, rooms) { state.rooms = rooms },
  },

  actions: {

    getRooms: () => Vue.axios.get(API_URL + '/rooms', { params: {
      sorts: [{"column":"rooms.order","order":"asc"}]
    }}),

    async getList({ commit, dispatch }) {
      const rooms = await dispatch('getRooms');
      commit('setProgress', false, { root: true });
      commit('setRooms', rooms.data.items);
    },

    async updateRooms({ state, rootState, commit }) {
      if (!rootState.progress) {
        const rooms = await Vue.axios.put(API_URL + '/rooms', state.rooms);
        commit('setProgress', false, { root: true });
        commit('setRooms', rooms.data);
      }
    },

    async toggleRoom({ state, commit }, room) {
      const response = await Vue.axios.put(API_URL + '/rooms/' + room.id, { publish: !room.publish });
      commit('setProgress', false, { root: true });
      const key = state.rooms.findIndex(item => item.id === room.id);
      state.rooms[key].publish = response.data.publish;
    },

  }
}
